import React, { useState, forwardRef, useImperativeHandle } from "react";
import { useEffect } from "react";
import OutsideClickHandler from "react-outside-click-handler";
import { useRef } from "react";
export const FilterData = forwardRef(({ ArrayList, FilterKey, onSelect, DefaultTitle, ListNameKey, formIkId, formIkError, formIkToched, formIkBlurHandler, disabled }, ref) => {
    const [Index, setIndex] = useState(0);
    const [SearchInput, setSearchInput] = useState("");
    const [IsDropDownActive, setDropDown] = useState(false);
    const dropdownRef = useRef(null)
    const [title, setTitle] = useState("");
    useEffect(() => {
        setTitle(DefaultTitle)
    }, [DefaultTitle]);
   const searchdown = (e) => {

        let currenttxtID = e.target.id;
        let UlID = "searchul";
        try {
            let selectList = document.getElementById(UlID);
            let Options = selectList.getElementsByTagName("li");
            switch (e.keyCode) {
                case 40:
                    Options[Index].className = "activeopt";
                    if (Index > 0)
                    Options[Index - 1].removeAttribute("class");
                    setIndex(Index + 1);
                    break;
                case 38:
                    if (Index > 0)
                    setIndex(Index - 1);
                    Options[Index].className = "activeopt";
                    Options[Index + 1].removeAttribute("class");
                   break;
                case 13:
                    setIndex(0);
                    let sectedOption = document.getElementsByClassName("activeopt");
                    let Text = "";
                    let filterList = ArrayList.filter((row) => row[FilterKey] == sectedOption[0].value);
                    if (filterList.length > 0) {
                        onSelect(filterList[0]);
                        setTitle(filterList[0][ListNameKey]);
                        setSearchInput("");
                    }
                    if (Index > 0)
                      Options[Index - 1].removeAttribute("class");
                    document.getElementById(currenttxtID).value = Text;
                   
                    break;
            }
        } catch (ex) { }
    };
    const onClickSelect = (value) => {
        const filterList = ArrayList?.filter(row => row[FilterKey] == value);
        onSelect(filterList[0]);
        setTitle(filterList[0][ListNameKey]);
        setSearchInput("");
        setDropDown(!IsDropDownActive);
    }
    const OpenCloseDrp = (e) => {
        e.preventDefault()
        setDropDown(prevState => prevState ? false : true)
        
    }

    useImperativeHandle(ref, () => ({
        autoOpenDropdown: () => {
            setDropDown(true)
        }
    }))

    return <>
       
        <OutsideClickHandler onOutsideClick={(e) => setDropDown(false)}>
            <div ref={dropdownRef }>
                {/*<button className="searchButtonCar packageForm" id="carname" onBlur={formIkBlurHandler} onClick={(e) => { OpenCloseDrp(e); }}>{title} <i className="fa fa-chevron-down" aria-hidden="true"></i></button>*/}
                <label className="life_searchButton">
                    <input className={`searchButtonCar packageForm ${disabled ? 'disabledButtonHouseWife' : ''}`} id="carname" type="button" name={formIkId} onBlur={formIkBlurHandler} onClick={(e) => { OpenCloseDrp(e) }} value={title} disabled={disabled} />
                    <i className={`fa fa-chevron-down Life_downIcon ${disabled ? 'disabledfa_chevron_down' : ''}`} aria-hidden="true"></i>
                </label>
            {IsDropDownActive && (
                <div className="manageDrpDwn">      
                    <input type="text" className=" " placeholder="Search..." onChange={(e) =>  setSearchInput(e.target.value.toLowerCase())} onKeyDown={searchdown} autoComplete="off" id="searchtext" autoFocus />
                    <ul id="searchul">
                        {ArrayList?.filter(row => row[ListNameKey]?.toLowerCase().match(SearchInput))?.map((row, i) => <li key={i} value={row[FilterKey]} onClick={(e) => onClickSelect(row[FilterKey])}>{row[ListNameKey]}</li>)}
                    </ul>
                </div>
                )}

                {formIkError?.[formIkId] && formIkToched?.[formIkId] && !IsDropDownActive ? (
                    <span className="errors-msg">
                        {formIkError?.[formIkId]?.toString()}
                    </span>
                ) : null}
            </div>
        </OutsideClickHandler>       
    </>
})